import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { recordReferralInfo } from "../../redux/actions/referral";

interface ReferralParams {
  event: string | null;
  url: string | null;
  source: string | null;
}

const ReferralRedirectView: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const parseQueryParams = (): ReferralParams => ({
    event: searchParams.get("event"),
    url: searchParams.get("url"),
    source: searchParams.get("source"),
  });

  useEffect(() => {
    const referralParams = parseQueryParams();

    const referralData = {
      referralData: {
        event: referralParams.event ?? "",
        url: referralParams.url ?? "",
        source: referralParams.source ?? "",
      },
    };

    recordReferralInfo(referralData);

    if (referralParams.url) {
      navigate(`/${referralParams.url}`);
    }
  }, [searchParams, navigate]);

  return <div />;
};

export default ReferralRedirectView;
